export const useSystemCommentsStore = () => {
  return useSystemComments()();
};
